import { UserPermissionListFactory } from "./user-permission-list.factory";
import { UserRole } from "src/app/ui/models/domains/pbm/user/user-role";

export class UserRoleListFactory {
  static createUserRoleList(payload: any[]): UserRole[] {
    const userRoleList: UserRole[] = payload.map((item) => {
      const userRole = new UserRole();
      userRole.setUserRoleKey(item.userRoleKey);
      userRole.setName(item.name);
      userRole.setUserPermissionList(UserPermissionListFactory.createUserPermissionList(item.userPermissionList));
      userRole.setUserRoleType(item.userRoleType);
      return userRole;
    });
    return userRoleList;
  }
}
